import React from "react";

import { cn } from "@/lib/utils";

import { CommandGroup as CommandGroupPrimitive } from "cmdk";

const CommandGroup = React.forwardRef<
  React.ElementRef<typeof CommandGroupPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandGroupPrimitive>
>(({ className, ...props }, ref) => (
  <CommandGroupPrimitive
    ref={ref}
    className={cn(
      "overflow-y-auto overflow-x-hidden border border-secondary rounded-md p-2",
      className,
    )}
    {...props}
  />
));

CommandGroup.displayName = CommandGroupPrimitive.displayName;
export { CommandGroup };
